<div class="container-fluid px-4 py-0">
  <div class="row">
    <!-- 1st div -->
    <div class="col-1 ">
      <nav class="navbar navbar-expand-lg p-0 ">

        <div class="container-fluid px-2 pb-1 m-0 hover-coursor">
          <!-- logo -->
          <p class="navbar-brand" href="#">
            <img (click)="goback()" src="assets/images/tetherfi-logo-round.png" data-bs-toggle="tooltip"
              data-bs-placement="top" title="Secure Work from Home (SWFH)" width="43" height="43" alt="">
          </p>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
            </ul>
          </div>
        </div>
      </nav>
    </div>

    <!-- 2nd div -->
    <div class="col-11 pt-2 pb-0">
      <div class="p-2 float-end">
        <div class="d-flex flex-row gap-3">
          <div class="collapsible-header d-flex ">
            <ng-container *ngIf="appConfig.settings.Dashboard.Enable && currentProfile != 'dashboard'">
              <i (click)="loadDashBoardView()" class="fal fa-grip-horizontal hover-coursor icon_hover"
                style="font-size: 20px; margin-top: 1px;" title="{{dashboardLabel}}" data-bs-placement="bottom"
                aria-hidden="true" data-bs-toggle="tooltip"></i>
            </ng-container>

            <ng-container *ngIf="appConfig.settings.Gamification.Enable">
              <i (click)="loadGamificationView()" class="fal fa-medal hover-coursor icon_hover"
                style="font-size: 20px;margin-left: 8px;" title="{{gamificationLabel}}" data-bs-placement="bottom"
                aria-hidden="true" data-bs-toggle="tooltip"></i>
            </ng-container>


            <ng-container *ngIf="isAllDataLoaded">
              <i (click)="loadSuperAdminUI()" class="fal fa-user-crown hover-coursor icon_hover"
                *ngIf="showSuperAdminIcon && currentProfile == 'supervisor'"
                [ngClass]="dashboardView || gamificationView? 'disabled_icon': ''"
                style="font-size: 20px;margin-left: 8px;" title="{{superadminLabel}}" data-bs-placement="bottom"
                aria-hidden="true" data-bs-toggle="tooltip"></i>

              <i (click)="loadSuperAdminUI()" class="fal fa-user-tag hover-coursor icon_hover" *ngIf="currentProfile == 'dashboard' || 
              currentProfile == 'gamification' || currentProfile == 'superadmin'"
                style="font-size: 20px;margin-left: 8px;" title="{{supervisorLabel}}" data-bs-placement="bottom"
                aria-hidden="true" data-bs-toggle="tooltip"></i>
            </ng-container>

            <i (click)="toggleSound()" class="fal fa-volume-up hover-coursor icon_hover"
              *ngIf="isNotificationSoundIconVisible" style="font-size: 20px;margin-left: 8px;"
              title="{{muteNotificationLabel}}" data-bs-placement="bottom" aria-hidden="true"
              data-bs-toggle="tooltip"></i>

            <!-- mute icon -->
            <i (click)="toggleSound()" class="fal fa-volume-slash hover-coursor icon_hover"
              *ngIf="!isNotificationSoundIconVisible" style="font-size: 20px;margin-left: 8px;"
              title="{{unmuteNotificationLabel}}" data-bs-placement="bottom" aria-hidden="true"
              data-bs-toggle="tooltip"></i>
          </div>

          <div class="d-flex flex-row gap-2 pl-1 pr-1 border border-1 rounded-3 p-1 h-30">
            <img width="20" height="20" padding-left="3px" class="pl-2 pr-2" src={{wsService.supervisorProfilePicture}}
              data-bs-toggle="tooltip" data-bs-placement="top" title="{{userName}}" alt="">
            <h6 class="header-text font-sm align-items-center mt-1 sm-d-none">{{ userName }}</h6>
            <!-- logout icon -->
            <i class="fal fa-sign-out-alt header-text pt-1 hover-coursor" data-bs-toggle="tooltip"
              data-bs-placement="left" title="{{logoutLabel}}" (click)="logout()" *ngIf="showLogout"></i>
          </div>

          <!-- signal icon -->
          <div *ngIf="supervisorConnectivityStatus;then success else warning"></div>
          <ng-template #success>
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="{{serverConnectivityLabel}}" width="20"
              height="20" padding-left="3px" class="pl-2 pr-2" src="assets/icons/supervisor_connectivity_full.png">
          </ng-template>
          <ng-template #warning>
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="{{serverConnectivityLabel}}" width="20"
              height="20" class="pl-2 pr-2" padding-left="3px" src="assets/icons/supervisor_connectivity_poor.png" />
          </ng-template>
        </div>
      </div>

      <div class="p-2 float-end">
        <!-- toggle -->
        <div class="d-flex flex-row">
          <div class="px-2 hover-coursor">
            <label>
              <input class="toggle-checkbox" type="checkbox" (change)="changeTheme()"
                [checked]="supervisorService.selectedTheme$.value === 'dark'">
              <div class="toggle-slot" title="{{changeThemeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top">
                <div class="sun-icon-wrapper hover-coursor">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"
                    focusable="false" width="1em" height="1em"
                    style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                    preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" class="iconify sun-icon"
                    data-icon="feather-sun" data-inline="false">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                      <circle cx="12" cy="12" r="5"></circle>
                      <path d="M12 1v2"></path>
                      <path d="M12 21v2"></path>
                      <path d="M4.22 4.22l1.42 1.42"></path>
                      <path d="M18.36 18.36l1.42 1.42"></path>
                      <path d="M1 12h2"></path>
                      <path d="M21 12h2"></path>
                      <path d="M4.22 19.78l1.42-1.42"></path>
                      <path d="M18.36 5.64l1.42-1.42"></path>
                    </g>
                  </svg>
                </div>
                <div class="toggle-button"></div>
                <div class="moon-icon-wrapper hover-coursor">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"
                    focusable="false" width="1em" height="1em"
                    style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                    preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" class="iconify moon-icon"
                    data-icon="feather-moon" data-inline="false">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                      <path d="M21 12.79A9 9 0 1 1 11.21 3A7 7 0 0 0 21 12.79z"></path>
                    </g>
                  </svg>
                </div>
              </div>
            </label>
          </div>

          <app-trs-sm-timer class="app-trs-sm-timer xs-d-none" *ngIf="isAllDataLoaded"></app-trs-sm-timer>
        </div>
      </div>
    </div>
  </div>
</div>